import { SectorsService } from 'data/services';
import { SectorsServiceInterface } from 'domain/services';
import { makeRemoteCreateSector } from 'main/factories/usecases/sectors/create-sector-factory';
import { makeRemoteDeleteSector } from 'main/factories/usecases/sectors/delete-sector-factory';
import { makeRemoteGetAllSectors } from 'main/factories/usecases/sectors/get-all-sectors-factory';
import { makeRemoteGetSectorById } from 'main/factories/usecases/sectors/get-sector-by-id-factory';
import { makeRemoteUpdateSector } from 'main/factories/usecases/sectors/update-sector-factory';

export const makeSectorsService = (): SectorsServiceInterface => {
  return new SectorsService({
    getAllSectors: makeRemoteGetAllSectors(),
    getSectorById: makeRemoteGetSectorById(),
    createSector: makeRemoteCreateSector(),
    updateSector: makeRemoteUpdateSector(),
    deleteSector: makeRemoteDeleteSector(),
  });
};
